<template>
  <el-row
    id="engagementSummaryRow"
    :gutter="5"
    type="flex"
    style="flex-wrap: wrap;"
    :class="['mobile', 'tablet'].includes($mq) ? 'mobileRow' : 'deskRow'"
  >
    <el-col :span="responsiveCol.one">
      <el-card
        class="clear-card firstCard"
        shadow="hover"
      >
        <div class="name">
          {{ engagement.leader_info ? engagement.leader_info.name : '' }}
        </div>

        <div
          v-if="displayDetails"
          class="details"
          style="margin-top: 15px;"
        >
          <el-button
            :style="`
              padding: 8px 10px;
              background-color: transparent;
              color: var(--themeFontColor);
              word-break: break-word;
              white-space: normal;`"
            round
            @click="showDetails = true"
          >
            {{ $t('settings.viewDetails') }}
          </el-button>
        </div>
        <div
          v-else
          class="duration"
        >
          {{ engagement.duration }} {{ $t('coach.engagements.durationSessions') }}
        </div>
      </el-card>
    </el-col>

    <el-col :span="responsiveCol.one">
      <el-card
        class="clear-card startDateCard"
        shadow="hover"
        :body-style="{
          height: 'calc(100% - 58px)',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }"
      >
        <div
          slot="header"
          class="header"
        >
          {{ $t('common.startDate') }}
        </div>

        <div>
          {{ engagement.start_date }}
        </div>
      </el-card>
    </el-col>

    <el-col :span="responsiveCol.one">
      <el-card
        class="clear-card endDateCard"
        shadow="hover"
        :body-style="{
          height: 'calc(100% - 58px)',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }"
      >
        <div
          slot="header"
          class="header"
        >
          {{ $t('common.endDate') }}
        </div>

        <div>
          {{ engagement.end_date }}
        </div>
      </el-card>
    </el-col>

    <el-col :span="responsiveCol.two">
      <el-card
        class="clear-card lgaCard"
        shadow="hover"
        :body-style="{
          height: 'calc(100% - 58px)',
          boxSizing: 'border-box',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }"
      >
        <div
          slot="header"
          class="header"
        >
          {{ $t('common.lgaLong') }}
        </div>

        <div class="content">
          <div>
            {{ engagement.lga1 }}
          </div>
          <div>
            {{ engagement.lga2 }}
          </div>
        </div>
      </el-card>
    </el-col>

    <EngagementLeaderDetails
      v-if="displayDetails"
      :show.sync="showDetails"
      :engagement="engagement"
    />
  </el-row>
</template>

<script>
import EngagementLeaderDetails from './EngagementLeaderDetails.vue';

export default {
  name: 'EngagementSummary',

  components: {
    EngagementLeaderDetails,
  },

  props: {
    engagement: {
      type: Object,
      default: null,
    },

    displayDetails: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showDetails: false,
  }),

  computed: {
    responsiveCol() {
      const col = {};
      if (['mobile', 'tablet'].includes(this.$mq)) {
        col.one = 12;
        col.two = 12;
      } else {
        col.one = 5;
        col.two = 9;
      }
      return col;
    },
  },
};
</script>

<style lang="scss" scoped>
  #engagementSummaryRow {
    &.mobileRow {
      .el-col {
        padding-bottom: 5px;

        .el-card {
          border-radius: 10px !important;
        }
      }
    }

    .el-card {
      height: 100%;
      text-align: center;

      &.firstCard {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;

        .name {
          margin-top: 25px;
          font-weight: bold;
          word-break: break-word;
        }

        .duration {
          margin-top: 10px;
          font-style: italic;
        }
      }

      &.startDateCard,
      &.endDateCard {
        border-radius: 0;
        font-weight: bold;
      }

      &.lgaCard {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;

        .content {
          font-style: italic;
        }
      }

      .header {
        font-weight: bold;
        text-align: center;
      }
    }
  }
</style>
